const Facebook = () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_937_747)'>
      <path
        d='M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z'
        fill='white'
      />
      <path
        d='M18.5 20.625V31.8056C18.1667 31.8704 17.2 32 16 32C14.8 32 13.8333 31.8704 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8887 6.25 19.5434 6.25C21.294 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1074C19.1198 10.5 18.5 11.7333 18.5 12.9987V16H22.9375L22.2281 20.625H18.5Z'
        fill='#121432'
      />
    </g>
    <defs>
      <clipPath id='clip0_937_747'>
        <rect width='32' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default Facebook
